import { IError } from '../interfaces/IError';

const incorrectChainIDError: IError = {
  errorDescription: `Only ${process.env.REACT_APP_SUPPORTED_CHAIN} is supported`,
  errorMessage: `Unsupported network. Please switch to ${process.env.REACT_APP_SUPPORTED_CHAIN}`,
  hideBtn: true,
};

export { incorrectChainIDError };
